const DEFAULT_RETURN_PATH = "/play";

function internalPath(value) {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    /[\\\u0000-\u001f\u007f]/.test(value)
  ) {
    return null;
  }

  // A saved Google redirect must remain on this site, including after decoding.
  // Query values can legitimately contain URLs, so only decode the pathname.
  try {
    const pathname = decodeURIComponent(value.split(/[?#]/, 1)[0]);
    if (pathname.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(pathname)) {
      return null;
    }
  } catch {
    return null;
  }

  return value;
}

export function getAuthReturnPath(from, fallback = DEFAULT_RETURN_PATH) {
  const safeFallback = internalPath(fallback) || DEFAULT_RETURN_PATH;
  if (typeof from === "string") return internalPath(from) || safeFallback;
  if (!from || typeof from.pathname !== "string") return safeFallback;

  const search = typeof from.search === "string" && from.search.startsWith("?")
    ? from.search : "";
  const hash = typeof from.hash === "string" && from.hash.startsWith("#")
    ? from.hash : "";

  return internalPath(from.pathname + search + hash) || safeFallback;
}
